<template>
  <div class="d-flex justify-space-between align-center">
    <v-btn v-if="!semSetas" icon text color="primary" :disabled="disabled" @click="subDate">
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>

    <v-menu
      v-model="menu"
      :disabled="disabled"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" depressed rounded :color="color" :disabled="disabled">
          {{ dateFormatted }}
        </v-btn>
      </template>

      <v-card>
        <v-date-picker v-model="date" type="month" locale="pt-BR" color="primary" no-title @input="selecionarData" />
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="setHoje">
            <v-icon left>mdi-calendar</v-icon>
            Hoje
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <v-btn v-if="!semSetas" icon text color="primary" :disabled="disabled" @click="addDate">
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'z-date-navigation',
  props: {
    value: {
      type: String,
      default: null,
    },
    disabled: Boolean,
    semSetas: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
  data() {
    return {
      menu: false,
      date: this.normalizarData(this.value),
    };
  },
  computed: {
    dateFormatted() {
      if (!this.date) {
        return '';
      }

      const [ano, mes] = this.date.split('-');
      const nomesMeses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
      return `${nomesMeses[Number(mes) - 1]} de ${ano}`;
    },
  },
  watch: {
    value(value) {
      const data = this.normalizarData(value);
      if (data !== this.date) {
        this.date = data;
      }
    },
  },
  mounted() {
    if (!this.value) {
      this.emitirData();
    }
  },
  methods: {
    normalizarData(value) {
      if (/^\d{4}-\d{2}$/.test(value || '')) {
        return value;
      }

      const hoje = new Date();
      return `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}`;
    },
    emitirData() {
      this.$emit('input', this.date);
      this.$emit('change', this.date);
    },
    selecionarData() {
      this.menu = false;
      this.emitirData();
    },
    alterarMes(quantidade) {
      const [ano, mes] = this.date.split('-').map(Number);
      const data = new Date(ano, mes - 1 + quantidade, 1);
      this.date = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}`;
      this.emitirData();
    },
    addDate() {
      this.alterarMes(1);
    },
    subDate() {
      this.alterarMes(-1);
    },
    setHoje() {
      this.date = this.normalizarData(null);
      this.menu = false;
      this.emitirData();
    },
  },
};
</script>
